import { useState } from 'react';
import { Navigate } from 'react-router';
import { useMe } from '../../data/hooks';
import { ScreenHeader } from '../../ui/ScreenHeader';
import { Segmented } from '../../ui/Segmented';
import { AppSettingsPanel } from './AppSettingsPanel';
import { AuditPanel } from './AuditPanel';
import { InvitesPanel } from './InvitesPanel';
import { UsersPanel } from './UsersPanel';

type Tab = 'users' | 'invites' | 'audit' | 'settings';

export function AdminScreen() {
  const me = useMe();
  const [tab, setTab] = useState<Tab>('users');
  if (me?.user.role !== 'super_admin') return <Navigate to="/" replace />;
  return (
    <div className="flex flex-col gap-4 md:max-w-2xl">
      <div className="flex flex-col gap-1">
        <ScreenHeader title="Admin" back={{ to: '/settings', label: 'Settings' }} />
        <p className="text-sm text-muted">Every change here goes into the audit log.</p>
      </div>
      <Segmented<Tab>
        label="Admin sections"
        value={tab}
        onChange={setTab}
        options={[
          { value: 'users', label: 'Users' },
          { value: 'invites', label: 'Invites' },
          { value: 'audit', label: 'Audit log' },
          { value: 'settings', label: 'Settings' },
        ]}
      />
      {tab === 'users' ? <UsersPanel /> : null}
      {tab === 'invites' ? <InvitesPanel /> : null}
      {tab === 'audit' ? <AuditPanel /> : null}
      {tab === 'settings' ? <AppSettingsPanel /> : null}
    </div>
  );
}
